import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { logout } from './authenticationSlice';
import { TourStepEnum } from 'features/onboarding/enums';
import { DEFAULT_TOUR_STEP, getNextTourStep } from 'utils/onboardingUtils';

interface OnboardingState {
  isWelcomeTourRunning: boolean;
  activeTourStep: TourStepEnum | undefined;
  completedTourSteps: Array<TourStepEnum>;
}

const initialState: OnboardingState = {
  isWelcomeTourRunning: false,
  completedTourSteps: [],
  activeTourStep: undefined,
};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    startWelcomeTour: (): OnboardingState => ({
      ...initialState,
      isWelcomeTourRunning: true,
      activeTourStep: DEFAULT_TOUR_STEP,
    }),
    nextTourStep: (
      state: OnboardingState,
      action: PayloadAction<TourStepEnum>,
    ): OnboardingState => {
      const completedTourSteps = [...state.completedTourSteps];

      if (!completedTourSteps.includes(action.payload)) {
        completedTourSteps.push(action.payload);
      }

      return {
        ...state,
        completedTourSteps,
        activeTourStep: getNextTourStep(action.payload),
      };
    },
    finishWelcomeTour: (): OnboardingState => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      Object.assign(state, initialState);
    });
  },
});

const { reducer, actions } = onboardingSlice;
const { startWelcomeTour, finishWelcomeTour, nextTourStep } = actions;

export { nextTourStep, startWelcomeTour, finishWelcomeTour };
export default reducer;
